<template>
    <div>
        <div class="card">
            <div class="card-body text-center">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-10 col-xl-8">
                        <!-- Image -->
                        <img
                            src="@/assets/img/illustrations/scale.svg"
                            alt="..."
                            class="img-fluid my-3"
                            style="max-width: 272px;"
                        />
                        <h2>{{$t('Legal information')}}</h2>
                        <p
                            class="text-muted"
                        >{{$t('Legal information provided in this section will be used for all your invoices and other legal documents')}}</p>

                        <router-link :to="{name:'company.invoice'}" class="btn btn-primary">{{$t('View sample')}}</router-link>
                    </div>
                </div>
                <!-- / .row -->
            </div>
        </div>
        <!-- Form -->
        <form class="mb-4">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>{{$t('Legal name')}}</label>
                        <b-form-input v-model="model.legalName"></b-form-input>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label>{{$t('First name')}}</label>
                        <b-form-input v-model="model.firstName"></b-form-input>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label>{{$t('Last name')}}</label>
                        <b-form-input v-model="model.lastName"></b-form-input>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label>Email</label>
                        <b-form-input v-model="model.email"></b-form-input>
                    </div>
                </div>

                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label>{{$t('Phone')}}</label>
                        <phone-field v-model="model.phone"></phone-field>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label>{{$t('Secondary phone')}}</label>
                        <b-form-input v-model="model.secondaryPhone"></b-form-input>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <label class="mb-1">{{$t('Address')}}</label>

                        <b-form-textarea
                            id="textarea2"
                            v-model="model.address"
                            placeholder="Enter company description"
                            :rows="2"
                            :max-rows="6"
                        ></b-form-textarea>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <label class="mb-1">{{$t('Notes')}}</label>

                        <b-form-textarea
                            id="notes"
                            v-model="model.notes"
                            :placeholder="$t('Enter notes for all invoices')"
                            :rows="2"
                            :max-rows="6"
                        ></b-form-textarea>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <label class="mb-1">{{$t('Invoice prefix')}}</label>
                        <b-form-input id="invoice-prefix" v-model="counters.invoicePrefix" :placeholder="$t('')"></b-form-input>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <label class="mb-1">{{$t('Invoice counter')}}</label>
                        <b-form-input
                            v-model.number="counters.invoiceCounter"
                            min="0"
                            type="number"
                            id="invoice-counter"
                            placeholder="3243"
                        ></b-form-input>
                    </div>
                </div>
            </div>
            <input type="hidden" v-model="company._v" />
            <button-loading
                class="btn btn-lg btn-primary mb-3"
                :loading="isSavePending"
                @click="saveCompany()"
            >{{$t('Save')}}</button-loading>
        </form>
    </div>
</template>

<script>
import Navigation from './Navigation.vue';
import PhoneField from "@/components/PhoneField.vue";
import ButtonLoading from '@/components/ButtonLoading'
import { companyMixins } from './mixins.js'

export default {
    mixins: [companyMixins],
    components: {
        Navigation,
        PhoneField,
        ButtonLoading
    },
    watch: {
        model: {
            handler(newValue) {
                this.company.billing = newValue;
            },
            deep: true
        },

        counters: {
            handler(newValue) {
                this.company.counters = newValue;
            },
            deep: true
        }
    },

    data() {
        return {
            model: {},
            counters: {}
        };
    },

    created() {
        this.getMyCompany("mine").then(data => {
            this.model = data.billing || {};
            this.counters = data.counters || {};
        });
    }
}
</script>
